(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      // On homepage (body.template-index-) opt out of the always-sticky path
      // even when sticky_header_type is 'always' or 'reduce-logo-size'.
      // This lets hide()/reveal()/reset() run normally so the announcement bar
      // and header hide and reveal together on scroll, matching every other page.
      this.headerIsAlwaysSticky =
        !document.body.classList.contains('template-index-') &&
        (this.getAttribute('data-sticky-type') === 'always' ||
         this.getAttribute('data-sticky-type') === 'reduce-logo-size');
      this.headerBounds = {};

      // Announcement bar integration — find the bar section once.
      // hide()/reveal()/reset() will manage its classes directly so
      // there is no MutationObserver race and no stale CSS variable.
      this.announcementBar = document.querySelector('.announcement-bar-section');

      this.setHeaderHeight();
      this.setAnnouncementBarHeight();

      // Re-measure after window load catches images / late-loading resources.
      window.addEventListener('load', this.setAnnouncementBarHeight.bind(this));

      // Re-measure after custom fonts are applied.
      // theme-style.css loads PP Neue Montreal and Helvetica Neue from CDN,
      // so connectedCallback fires with fallback fonts — the announcement bar
      // can be several pixels shorter than its true post-font height. That gap
      // means --announcement-bar-sticky-height is too small, and the header
      // sticks too high, partially behind the bar ("cut-off / top spacing
      // missing" on desktop homepage). document.fonts.ready resolves once all
      // fonts are downloaded and applied, giving the accurate offsetHeight.
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
          this.setHeaderHeight();
          this.setAnnouncementBarHeight();
        });
      }

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
      // Re-measure when viewport crosses the sticky-mobile/sticky-desktop
      // breakpoint so the offset stays accurate after orientation changes.
      window.matchMedia('(max-width: 749px)').addEventListener('change', this.setAnnouncementBarHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        // Re-measure in the next frame so the layout change from adding the
        // class is settled before the CSS variable is evaluated. On homepage:
        // header.header flips from position:absolute to position:static, so
        // .section-header gains its real height — setHeaderHeight() must run
        // AFTER this flip for --header-height to be correct.
        requestAnimationFrame(() => {
          this.setHeaderHeight();
          this.setAnnouncementBarHeight();
        });
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    // Measures the announcement bar height and writes two CSS variables:
    //   --announcement-bar-height        used for the bar's own hide offset
    //   --announcement-bar-sticky-height used to push the revealed header down
    //
    // We measure offsetHeight unconditionally rather than gating on
    // getComputedStyle().position === 'sticky'. The getComputedStyle check
    // could return 'static' at connectedCallback time (before stylesheets are
    // fully computed), writing 0px to the variable. On the homepage the header
    // is always-sticky so reveal() never re-measures — the 0px sticks and the
    // header appears at top:0 overlapping the bar.
    //
    // The CSS in announcement-bar.liquid already wraps the top offset rule in
    // a media query matching the sticky setting, so on viewports where the bar
    // is not sticky the rule never fires regardless of the variable value.
    setAnnouncementBarHeight() {
      if (!this.announcementBar) return;
      const h = this.announcementBar.offsetHeight;
      document.documentElement.style.setProperty('--announcement-bar-height',        `${h}px`);
      document.documentElement.style.setProperty('--announcement-bar-sticky-height', `${h}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      if (document.body.classList.contains('template-index-')) {
        // Homepage: keep the header visible and sticky at top:0.
        // Only the announcement bar hides. A CSS sibling rule in
        // announcement-bar.liquid applies top:0 to the header automatically
        // while announcement-bar-sticky-hidden is present on the bar.
        this.header.classList.add('shopify-section-header-sticky');
      } else {
        // All other pages: hide the header off-screen as normal.
        this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        // setHeaderHeight() after adding the sticky class: on homepage the
        // header was position:absolute (0 height) and would now flip to
        // position:static; on non-homepage it's already in flow. Either way
        // reading offsetHeight here gives the live value for --header-height.
        this.setHeaderHeight();
      }
      if (this.announcementBar) {
        this.announcementBar.classList.remove('announcement-bar-animate');
        this.announcementBar.classList.add('announcement-bar-sticky-hidden');
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      // Measure bar height synchronously BEFORE mutating classes so the
      // CSS variable is fresh when the browser evaluates the transition.
      this.setAnnouncementBarHeight();
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.announcementBar) {
        this.announcementBar.classList.add('announcement-bar-animate');
        this.announcementBar.classList.remove('announcement-bar-sticky-hidden');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.announcementBar) {
        this.announcementBar.classList.remove('announcement-bar-sticky-hidden', 'announcement-bar-animate');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
